import React from "react";
import useCameraStream from "../../MockCaseMain/hooks/useCameraStream";

interface CameraButtonProps {
    onClick: () => void;
    isActive?: boolean;
}

const CameraButton: React.FC<CameraButtonProps> = ({
    onClick,
    isActive = true,
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();

        console.log("Camera button clicked, isActive:", isActive);
        onClick();
    };

    const baseButtonClasses =
        "border-[1.5px] border-[#d4d6db] py-2 rounded-[8px] cursor-pointer  px-4 py-0 flex items-center justify-center ";

    return isActive ? (
        <button
            onClick={handleClick}
            aria-label="Camera Active"
            className={`${baseButtonClasses} bg-white`}>
            {/* Active camera icon (inline SVG) */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 30 24"
                fill="#444">
                <path
                    d="M3 24C2.175 24 1.46875 23.7063 0.88125 23.1188C0.29375 22.5312 0 21.825 0 21V3C0 2.175 0.29375 1.46875 0.88125 0.88125C1.46875 0.29375 2.175 0 3 0H21C21.825 0 22.5312 0.29375 23.1188 0.88125C23.7063 1.46875 24 2.175 24 3V9.75L28.725 5.025C28.975 4.775 29.25 4.7125 29.55 4.8375C29.85 4.9625 30 5.2 30 5.55V18.45C30 18.8 29.85 19.0375 29.55 19.1625C29.25 19.2875 28.975 19.225 28.725 18.975L24 14.25V21C24 21.825 23.7063 22.5312 23.1188 23.1188C22.5312 23.7063 21.825 24 21 24H3ZM3 21H21V3H3V21Z"
                    fill="#444444"
                />
            </svg>
            <div className="ml-2">Stop Video</div>
        </button>
    ) : (
        <button
            onClick={handleClick}
            aria-label="Camera Inactive"
            className={`${baseButtonClasses} bg-white `}>
            {/* Inactive camera icon (inline SVG) */}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 30 30"
                fill="#444">
                <path
                    d="M24.2652 11.5054L28.7814 6.98925C29.0203 6.7503 29.2832 6.69056 29.5699 6.81004C29.8566 6.92951 30 7.15651 30 7.49104V19.8208C30 20.1553 29.8566 20.3823 29.5699 20.5018C29.2832 20.6213 29.0203 20.5615 28.7814 20.3226L24.2652 15.8065C24.2652 16.2127 24.1278 16.5532 23.853 16.828C23.5783 17.1027 23.2378 17.2401 22.8315 17.2401C22.4253 17.2401 22.0848 17.1027 21.81 16.828C21.5352 16.5532 21.3979 16.2127 21.3979 15.8065V5.05376H11.362C10.8841 5.05376 10.5257 4.90442 10.2867 4.60573C10.0478 4.30705 9.92832 3.97849 9.92832 3.62007C9.92832 3.26165 10.0478 2.93309 10.2867 2.63441C10.5257 2.33572 10.8841 2.18638 11.362 2.18638H21.3979C22.1864 2.18638 22.8614 2.46714 23.4229 3.02867C23.9845 3.5902 24.2652 4.26523 24.2652 5.05376V11.5054ZM26.9176 28.9247L0.394265 2.40143C0.131422 2.13859 0 1.80406 0 1.39785C0 0.991637 0.131422 0.657109 0.394265 0.394265C0.657109 0.131422 0.991637 0 1.39785 0C1.80406 0 2.13859 0.131422 2.40143 0.394265L28.9247 26.9176C29.1876 27.1804 29.319 27.5149 29.319 27.9211C29.319 28.3274 29.1876 28.6619 28.9247 28.9247C28.6619 29.1876 28.3274 29.319 27.9211 29.319C27.5149 29.319 27.1804 29.1876 26.9176 28.9247ZM4.19355 2.18638L7.06093 5.05376H4.19355V22.2581H21.3979V19.3907L24.2652 22.2581C24.2652 23.0466 23.9845 23.7216 23.4229 24.2832C22.8614 24.8447 22.1864 25.1255 21.3979 25.1255H4.19355C3.40502 25.1255 2.72999 24.8447 2.16846 24.2832C1.60693 23.7216 1.32616 23.0466 1.32616 22.2581V5.05376C1.32616 4.26523 1.60693 3.5902 2.16846 3.02867C2.72999 2.46714 3.40502 2.18638 4.19355 2.18638Z"
                    fill="#444444"
                />
            </svg>
            <div className="ml-2">Start Video</div>
        </button>
    );
};

export default CameraButton;
